(function () {
  'use strict';

  // Farbpunkte für Töne, denen das Liquid keinen echten Farbwert gibt
  // (#cccccc ist dessen Platzhalter). Zwei Quellen, in dieser Reihenfolge:
  //
  //   1. CHART_HEX — verbindliche Werte aus der offiziellen SPARK-Farbkarte,
  //      pixelgenau aus der Vorlage ausgelesen.
  //   2. Swatch-Kachel aus den Shopify-Dateien: <handleisierter Optionswert>.png
  //      (Konvention der alten Produktseite, siehe snippets/color_swatch_customization.liquid).
  //
  // Fehlt beides, bleibt die Namens-Näherung aus pf-script.js stehen.
  // Angefragt wird die 60px-Variante des Shopify-CDN, damit versehentlich große
  // Dateien nicht ins Gewicht fallen.
  //
  // Hinweis: die Dateien SPARK_*.png sind Produktfotos der Dosen, keine Kacheln.

  var CHART_HEX = {
    // SPARK Sprühdose 400 ml — offizielle Farbkarte
    'blitzgelb': '#f8d71e',
    'verkehrsgelb': '#f3cc1a',
    'leuchtorange': '#e77527',
    'orange': '#d75928',
    'signalrot': '#d5372f',
    'rubinrot': '#852d2b',
    'feuerrot': '#c23a33',
    'kirschrot': '#9c1c33',
    'zartrosa': '#eb9aac',
    'lavendel-hell': '#d4a1c7',
    'telemagenta': '#da366d',
    'traubenlila': '#976aa2',
    'veilchenlila': '#6569a5',
    'hellblau': '#91c6e1',
    'himmelblau': '#1a71b3',
    'signalblau': '#075394',
    'kobaltblau': '#214b8a',
    'moosgrun': '#2f7043',
    'kiwigrun': '#81b942',
    'mentholgrun': '#73bd99',
    'beigebraun': '#bc965c',
    'nussbraun': '#6f4848',
    'macadamia-beige': '#e3c2ad',
    'terrakotta-pastellgrau': '#c8b8b5',
    'lichtgrau': '#dbd3cd',
    'terrakotta-grau': '#83696b',
    'mittelgrau': '#aeacaa',
    'anthrazitgrau': '#3e4245',
    'reinweiss': '#ffffff',
    'tiefschwarz': '#040008',
    'milchglas-weiss': '#e2ebf1',
    'gold': '#bc9c20',
    'silber': '#c0c0c0'
  };

  var MAX_PROBES = 60;
  var cache = {};

  function handleize(s) {
    return String(s || '').toLowerCase()
      .replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  // Liefert den Hintergrundwert für einen Optionswert — oder null.
  function backgroundFor(value) {
    var h = handleize(value);
    if (!h) return Promise.resolve(null);
    if (CHART_HEX[h]) return Promise.resolve(CHART_HEX[h]);

    var url = '/cdn/shop/files/' + h + '_60x.png';
    if (cache[url] !== undefined) return Promise.resolve(cache[url]);
    return new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () {
        cache[url] = 'url(' + url + ') center/cover no-repeat';
        resolve(cache[url]);
      };
      img.onerror = function () { cache[url] = null; resolve(null); };
      img.src = url;
    });
  }

  function init(root) {
    var dataEl = root.querySelector('[data-pf-colors]');
    if (!dataEl) return;

    var colors;
    try { colors = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var pos = parseInt(root.getAttribute('data-pf-color-position'), 10);
    if (isNaN(pos) || pos < 0) return;

    // Optionswert je Variante, aber nur für Töne ohne echten Farbwert.
    var wanted = {};
    var count = 0;
    colors.forEach(function (c) {
      var hex = String(c.hex || '').toLowerCase();
      if (hex && hex !== '#cccccc') return;
      var value = (c.options || [])[pos];
      if (!value) return;
      if (wanted[c.variantId] === undefined && count < MAX_PROBES) {
        wanted[c.variantId] = value;
        count++;
      }
    });
    if (!count) return;

    function apply(el, value) {
      if (!el || el.dataset.pfTile === '1') return;
      backgroundFor(value).then(function (bg) {
        if (!bg) return;
        el.style.background = bg;
        el.dataset.pfTile = '1';
      });
    }

    function paint() {
      // Farbpunkte im Drawer
      root.querySelectorAll('[data-pf-pick]').forEach(function (row) {
        var value = wanted[row.getAttribute('data-pf-pick')];
        if (!value) return;
        apply(row.querySelector('.pf-drawer-color-chip') || row, value);
      });

      // Ausgewählter Ton (Kaufbox, Sticky-Leiste, Bildüberlagerung).
      // Hier muss die Markierung zurückgesetzt werden, weil derselbe Punkt
      // bei jedem Wechsel einen anderen Ton zeigt.
      var input = root.querySelector('[data-pf-variant-input]');
      var value = input && wanted[input.value];
      root.querySelectorAll('[data-pf-sel-chip]').forEach(function (chip) {
        delete chip.dataset.pfTile;
        if (value) apply(chip, value);
      });
    }

    paint();

    // pf-script.js baut die Liste bei jeder Auswahl neu auf; danach erneut einfärben.
    var box = root.querySelector('[data-pf-drawer-list]') || root;
    new MutationObserver(function () { paint(); }).observe(box, { childList: true, subtree: true });
    root.addEventListener('click', function () { setTimeout(paint, 60); });
  }

  function boot() {
    document.querySelectorAll('[data-pf-root]').forEach(function (root) {
      if (root.dataset.pfTilesInit) return;
      root.dataset.pfTilesInit = '1';
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();